import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import { routingRulesLabels } from '../../../config/common';
import Hyperlink from '../../atoms/links/Hyperlink';
import { constructIds, protocolTypes } from '../../../config/common';
import { invokeGetService } from "../../../store/global/actions";


const useStyles = makeStyles((theme) => ({

    routingRuleTable: {
        width: '90%'
    },
    row: {
        borderBottom: '1px solid #ccc'
    },
    columnLabel: {
        padding: '10px 25px',
        width: '30%'
    },
    columnValue: {
        padding: '10px 25px',
        borderLeft: '1px solid #ccc',
        width: '60%'
    }
}));

export default function ViewRoutingRule({ item }) {
    console.log("ViewRoutingRule-------------------------------", item)
    const classes = useStyles();
    const dispatch = useDispatch();
    const keys = Object.keys(item?.attributes);

    const [events, setEvents] = useState([]);
    const [clusterlets, setClusterlets] = useState([]);
    // const rrDelegate = clusterlets.find(e => e._id === item.attributes.delegate);
    const [rrDelegate, setRrDelegate] = useState(null);
    const [sortingArr, setSortingArr] = useState([]);

    const routingRuleDataOrder = {
        [protocolTypes.http]: { 'IN': ['name', 'dir', 'commandtype', 'op', 'code', 'parameters', 'ttype', 'tcmd', 'tinstance', 'delegate'], 'OUT': ['name', 'dir', 'ttype', 'tcmd', 'commandtype', 'path', 'parameters', 'host', 'delegate'] },
        [protocolTypes.http2]: { 'IN': ['name', 'dir', 'commandtype', 'path', 'op', 'parameters', 'ttype', 'tcmd', 'tinstance', 'delegate'], 'OUT': ['name', 'dir', 'ttype', 'tcmd', 'commandtype', 'path', 'parameters', 'host', 'delegate'] },
        [protocolTypes.mqtt]: { 'IN': ['name', 'dir', 'type', 'topic', 'ttype', 'tcmd', 'tinstance', 'delegate'], 'OUT': ['name', 'dir', 'ttype', 'tcmd', 'commandcode', 'commandtype', 'delegate'] },
        [protocolTypes.diameter]: { 'IN': ['name', 'dir', 'commandcode', 'commandtype', 'vendorid', 'ttype', 'tcmd', 'tinstance', 'delegate'], 'OUT': ['name', 'dir', 'ttype', 'tcmd', 'commandcode', 'commandtype', 'delegate'] },
        [protocolTypes.radius]: { 'IN': ['name', 'dir', 'commandcode', 'commandtype', 'ttype', 'tcmd', 'tinstance', 'delegate'], 'OUT': ['name', 'dir', 'ttype', 'tcmd', 'commandcode', 'commandtype', 'delegate'] },
        [protocolTypes.asn1]: { 'IN': ['name', 'dir', 'type', 'nastype', 'parameters', 'ttype', 'tcmd', 'tinstance', 'delegate'], 'OUT': ['name', 'dir', 'ttype', 'tcmd', 'delegate'] }
    };

    useEffect(() => {
        dispatch(invokeGetService('getBlueprintConstructs', []))
            .then((response) => {
                if (response.data !== undefined) {
                    let delegate = response.data.clusterlets.find(e => e._id == item.attributes.delegate);
                    setClusterlets(response.data.clusterlets)
                    setEvents(response.data.events)
                    setRrDelegate(response.data.clusterlets.find(e => e._id == item.attributes.delegate))
                    setSortingArr((delegate?.attributes?.type && routingRuleDataOrder[delegate?.attributes?.type] && routingRuleDataOrder[delegate?.attributes?.type][item?.attributes?.dir]) ? routingRuleDataOrder[delegate?.attributes?.type][item?.attributes?.dir] : [])
                }


            })
    }, [])






    // const sortingArr = routingRuleDataOrder[rrDelegate?.attributes?.type][item?.attributes?.dir];
    const sortedKeys = keys.sort(function (a, b) {
        return sortingArr.indexOf(a) - sortingArr.indexOf(b);
    });
    const filteredParameters = item?.attributes?.parameters?.filter(obj => obj?.key !== '' && obj?.value !== '');



    return (
        <div className={classes.container}>

            {sortedKeys.length > 0 && <table className={classes.routingRuleTable}>
                <tbody>
                    {sortedKeys.map((key, index) => {
                        console.log("key : ", key)
                        console.log("item?.attributes?.key : ", typeof item?.attributes[key])
                        return (
                            <tr className={classes.row}>
                                <td className={classes.columnLabel}>{routingRulesLabels.find(e => e.value == key)?.label}</td>
                                <td className={classes.columnValue}>
                                    {
                                        // key === 'tcmd' ? <Hyperlink id={item.attributes.tcmd} type={'event'} item={events.find(e => e._id == item.attributes.tcmd)} screen={'information_flow'}> {events.find(e => e._id === item.attributes.tcmd)?.name} </Hyperlink>
                                        key === 'tcmd' ? <Hyperlink id={item.attributes.tcmd} type={'event'} item={events.find(e => e._id == item.attributes.tcmd)} screen={'transaction'}> {events.find(e => e._id === item.attributes.tcmd)?.name} </Hyperlink>

                                            : key === 'commandtype' ? (item?.attributes.commandtype == 'req' ? 'Request' : 'Response')
                                                : key === 'ttype' ? <Hyperlink id={item.attributes.ttype} type={constructIds.find(element => element.id == clusterlets.find(e => e._id == item.attributes.ttype)?.type)?.type} > {clusterlets.find(e => e._id == item.attributes.ttype)?.name}</Hyperlink>
                                                    : key === 'delegate' ? clusterlets.find(e => e._id == item.attributes?.delegate)?.name
                                                        : key === 'parameters' ? JSON.stringify(filteredParameters)
                                                            : item?.attributes[key]
                                    }


                                </td>


                            </tr>

                        )
                    })}
                </tbody>
            </table>}


        </div>

    );
}